import { Planner } from '../planner_base';
class Orders extends Planner {
  orders: any;
  init(){
    // 体感的な測度を上げるためopts.ordersを分割し、処理を僅かに遅延させる。
    super.init();
    this.orders = []
    if(this.opts.index == 0){
      this.listenMount([this.onMountPlanner]);
    }
  }
  onMountPlanner(){
    this.setOrdersAndUpdate();
  }
  setOrdersAndUpdate(){
    // this.on('updated', () => {console.log('updated'); this.parent['onUpdatedOrders'](this.opts.index)})
    // console.log(this.opts.index);
    this.orders = this.opts.orders;
    this.update();
    setTimeout(()=>{
      this.parent['onUpdatedOrders'](this.opts.index);
    }, 100);
  }
}
riot.mixin('orders.planner.orders', Orders as riot.TagMixin)
